'use client';
import { useRef } from 'react';
import Autoplay from 'embla-carousel-autoplay';

import { ourValues } from '@/app/(main)/(pages)/(institucional)/trabalhe-conosco/_consts/our-values.const';
import { Icon } from '@/components/ui/icon.component';
import { ContentContainer } from '@/components/ui/content-container.component';
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel.component';
import { DotsVariantEnum } from '@/components/ui/carousel-dot-button.component';

export function OurValues() {
  const plugin = useRef(Autoplay({ delay: 4000, stopOnInteraction: true }));

  return (
    <div className="bg-green-500">
      <ContentContainer className="pt-10 pb-6">
        <h2 className="text-center lg:text-left text-white font-bold text-xl mb-6">Nossos valores</h2>
        <Carousel
          plugins={[plugin.current]}
          onMouseEnter={plugin.current.stop}
          onMouseLeave={plugin.current.reset}
          orientation="horizontal"
          opts={{
            loop: false,
          }}
          data-testid="our-values-carousel"
          showDots
          hideDotsWhenCantScroll
          dotsColorVariant={DotsVariantEnum.SUCCESS}
        >
          <CarouselContent className="gap-3 sm:gap-4 !m-0 md:grid md:grid-cols-3 md:justify-center">
            {ourValues
              && ourValues.map((values, index) => (
                <CarouselItem
                  key={index}
                  className="bg-white py-6 px-5 border border-gray-100 rounded-2xl w-[19.5rem] md:w-full"
                >
                  <div className="flex flex-col items-center gap-3">
                    <div className="w-16 h-16 flex items-center justify-center">
                      <Icon icon={values.icon} size="4x" className="text-success-500 w-16 h-16" />
                    </div>
                    <h3 className="text-lg leading-5 font-semibold text-gray-900">{values.title}</h3>
                    <p className="text-base text-gray-600 text-center">{values.description}</p>
                  </div>
                </CarouselItem>
              ))}
          </CarouselContent>
        </Carousel>
      </ContentContainer>
    </div>
  );
}
